import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 pt-10 space-y-10" }
const _hoisted_2 = { class: "flex flex-col space-y-6 items-center" }
const _hoisted_3 = { class: "flex flex-col w-full items-center space-y-1 px-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-500 text-sm text-center leading-tight py-3 px-5"
}

import {onMounted, PropType, ref} from 'vue';
import {modalController} from "@ionic/vue";
import ApiService from "@/services/api/apiService";
import {UserProfileInterface} from "@/interfaces/UserProfileInterface";
import ProfileSettingsProfile from "@/views/user/profile/ProfileSettingsProfile.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {AccountType} from "@/definitions/AccountType";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSetupSheet',
  props: {
  user: {
    type: Object as PropType<UserBasicInformationInterface>
  }
},
  setup(__props) {


const loading = ref(true)

onMounted(async () => {
  loading.value = false
})

const props = __props

const dismiss = async () => {
  await modalController.dismiss()
}

const busy = ref(false)

const setup = async () => {
  if (busy.value) return
  busy.value = true
  await modalController.dismiss()
  const profile = await ApiService.User().createProfile()
  await viewProfile(profile)

}

const viewProfile = async (profile: UserProfileInterface) => {
  const modal = await modalController.create({
    component: ProfileSettingsProfile,
    mode: 'ios',
    componentProps: {
      profile
    },
    presentingElement: document.getElementById('tabs') as HTMLElement,
  })
  await modal.present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex text-brand-lime" }, [
        _createElementVNode("svg", {
          class: "w-16 h-16 fill-current",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 448 512"
        }, [
          _createElementVNode("path", { d: "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Your Profile", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center leading-tight" }, "It's time to setup your profile to help others get to know you.", -1)),
        (__props.user?.account_type === _unref(AccountType).Joint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "As a joint account you can have more than one profile for each of you in the relationship. You'll be able to add another profile after you've added your first."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "flex flex-col space-y-2 w-full items-center" }, [
        _createElementVNode("button", {
          onClick: setup,
          class: "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "flex w-full m-auto space-x-2.5" }, [
            _createElementVNode("div", { class: "m-auto pt-0.5" }, [
              _createElementVNode("div", null, "Create Profile")
            ])
          ], -1)
        ]))])
      ])
    ])
  ]))
}
}

})